export interface FiltroFundo {
  listaSetor: string[];
  listaMomento: string[];
  valorCheque: number;
  // chequeMaximo: number;
}

export interface FiltroUuid {
  uuid: string;
  nome: string;
  tipo: TipoFiltro;
}

export enum TipoFiltro {
  M,
  S,
}
